    <div class="max-w-5xl">
    <mat-tab-group (selectedTabChange)="retriveHours($event.index)" >
        <mat-tab *ngFor="let originalTerm of originalTermData; index as i" 
            label="{{originalTerm.serviceName}} {{originalTerm.fromDate | date:'HH:mm'}} - {{originalTerm.toDate | date:'HH:mm'}}"
            >
            <form #vacuForm="ngForm" >
                <div class="containerdiv">
                    <div>
                        <div class="form">
                            <div class="box width_100_percent">
                                <mat-divider style="padding-bottom: 2vh; font-size: large;"></mat-divider>

                                <div class="parent" style="padding-bottom: 2vh;">
                                    <div class="div1">
                                        <i class="fa-regular fa-calendar-lines-pen" style="font-size: 5vh;"></i>
                                    </div>
                                    <div class="div2">
                                        <span style="font-size: large; font-weight: bold;">{{originalTerm.serviceName}}</span>
                                        <span style="font-weight: lighter;">{{originalTerm.fromDate | date:'dd.MM.yyyy'}}  {{originalTerm.fromDate | date:'HH:mm'}} - {{originalTerm.toDate | date:'HH:mm'}}</span>
                                        <span style="font-weight: lighter;">{{originalTerm.name}} {{originalTerm.surname}}</span>
                                    </div>
                                    <div class="div3">
                                        <span class="timeStyle max-sm:text-center" style="font-size: 18px;">{{ totalMinutesArray[i] }} {{"min" | translate }}</span>
                                    </div>
                                </div>
                                <button *ngIf="termData[i].cancelled==false" mat-button style="padding: 1vh;" (click)="cancelTermActive=true" class="center align-middle bg-red-500 text-white w-full">
                                        <p><i class="fa-solid fa-xmark" ></i> {{"Cancel term" | translate}}</p>
                                </button>

                                <!-- Cancel Term -->

                                <div *ngIf="cancelTermActive==true">
                                    <div class="padding_20">
                                      <div class="box width_100_percent">
                                        <div>
                                          <div class="flex flex-col gap-5">
                                            <div class="w-full flex flex-row gap-[0.85rem] justify-between align-middle items-center text-black">
                                                <mat-checkbox [ngModelOptions]="{standalone: true}" [aria-label]="'confirmationCheckboxMobile'" class="text-wrap font-normal" [(ngModel)]="confirmCancel" ></mat-checkbox>
                                                <p class="text-[1rem] sm:text-[1.35rem] w-full ">{{"Are you sure do you have to cancel this term?" | translate}}</p>
                                              </div>
                                  
                                  
                                          </div>
                                        </div>
                                  
                                        <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem] mt-2">
                                          <button (click)="cancelTermActive=false" type="button"
                                            class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
                                            {{"No" | translate}}
                                          </button>
                                
                                          <button (click)="cancelTerm()" [disabled]="confirmCancel!=true" [ngClass]="{
                                            'bg-[#b98d78] hover:bg-[#a57d6a] active:scale-[0.985] active:shadow-sm': confirmCancel==true,
                                            'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': confirmCancel==false 
                                            }"
                                            class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm bg-[#b98d78] hover:bg-[#a57d6a]">
                                            {{"Yes" | translate}}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                <mat-divider style="padding-bottom: 2vh;"></mat-divider>
                                <div class="flex flex-col gap-1 w-full">
                                    <mat-label>{{"Select employee" | translate}}</mat-label>
                                    <mat-form-field appearance="outline" class="flex flex-row items-center">
                                        <mat-icon matPrefix><i class="fa-regular fa-square-user"></i></mat-icon>
                                        <mat-select [(ngModel)]="termData[i].employeeProfileId"
                                            placeholder='{{"Select employee" | translate}}' (ngModelChange)="resetDateTime(i)"
                                            name="selectEmployee" #selectEmployee="ngModel" required>
                                            <mat-option *ngFor="let employee of employeeData" [value]="employee.profileId">
                                                {{employee.name}} {{employee.surname}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="selectEmployee && selectEmployee.errors">
                                            <span *ngIf="selectEmployee.errors['required']">{{"Required Field" | translate}}</span>
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-label>{{"Select a date" | translate}}</mat-label>
                                    <mat-form-field class="flex flex-row items-center" appearance="outline">
                                        <mat-icon matPrefix><i class="fa-regular fa-calendar"></i></mat-icon>
                                        <input matInput [matDatepicker]="picker" [(ngModel)]="termData[i].fromDate"
                                            (dateChange)="retriveHours(i);" [min]="yesterday"
                                            placeholder='{{"Select a date" | translate}}' #date="ngModel" name="date" required>
                                        <mat-hint>{{"MM/DD/YYYY" | translate}}</mat-hint>
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <mat-error *ngIf="date && date.errors">
                                            <span *ngIf="date.errors['required']">{{"Required Field" | translate}}</span>
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-label>{{"Select a time" | translate}}</mat-label>
                                    <mat-form-field appearance="outline" class="flex flex-row items-center">
                                        <mat-icon matPrefix><i class="fa-regular fa-clock"></i></mat-icon>
                                        <mat-select placeholder='{{"Select a time" | translate}}' [(ngModel)]="hourSelection"
                                            #termHour="ngModel" name="termHour">
                                            <mat-option *ngFor="let termHour of termHourlyData" [value]="termHour">
                                                {{termHour | date:'HH:mm'}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="termHour && termHour.errors">
                                            <span *ngIf="termHour.errors['required']">{{"Required Field" | translate}}</span>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem]">
                            <button (click)="closePopup()" type="button"
                              class="w-1/2 px-5 py-[.5rem] uppercase rounded-[.25rem] bg-[#dadada] text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
                              {{"back" | translate}}
                            </button>
                      
                            <button [disabled]="!vacuForm" [ngClass]="{
                                  'bg-[#b98d78] hover:bg-[#a57d6a] ': vacuForm,
                                  'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': !vacuForm
                                }" (click)="editTerm(i)" class="w-1/2 uppercase px-5 py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
                              {{"Edit term" | translate}}
                            </button>
                          </div>
                    </div>
                </div>

            </form>
        </mat-tab>
    </mat-tab-group>
</div>

<!--Cancel term popup-->
<app-generic-modal *ngIf="cancleTermPopupState" [bannerText]="'Cancel term' | translate " [handle_extreme_overflow]="true"
  [handle_mobile]="true" (handleCloseEmitter)="closePopup()">

  <app-delete-component (close)="closePopup()" [termId]="termId" [serviceName]="serviceName"></app-delete-component>

</app-generic-modal>